import { render, staticRenderFns } from "./BP_editor.vue?vue&type=template&id=256e1239&scoped=true"
import script from "./BP_editor.vue?vue&type=script&lang=js"
export * from "./BP_editor.vue?vue&type=script&lang=js"
import style0 from "./BP_editor.vue?vue&type=style&index=0&id=256e1239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e1239",
  null
  
)

export default component.exports